let bbPop = (() => {
  
  const settings = {
    // Popup element selectors
    popup: document.querySelector('div.bbpop'),
    prodImg: document.querySelector('#bbpop-img'),
    imgLink: document.querySelector('#bbpop-img-link'),
    description: document.querySelector('#bbpop-description'),
    timeMsg: document.querySelector('#bbpop-time-msg'),
    
    // Popup timer settings
    firstInterval: 6, //seconds
    minInterval: 20, //seconds
    maxInterval: 45,  //seconds
    maxPops: 3, //per page
    
    // Other settings
    phoneWidth: 600,
    apiURL: 'https://us-central1-bbpop-34f6d.cloudfunctions.net/events'
  };

  let hidePop;
  if (document.cookie.split(';')
    .filter((item) => item.includes('bbPopHide=true')).length) {
      hidePop = true;
  } else { hidePop = false };

  const isPhone = () => {
    let windowWidth = window.innerWidth;
    if (windowWidth > settings.phoneWidth) {
      return false
    } else {
      return true
    };
  };

  const getEvents = async () => {
    try {
      const response = await fetch(settings.apiURL);
      if (response.ok) {
        return await response.json();
      } else { throw new Error(response.statusText) };
    }
    catch(error) {
      console.error('Could not fetch events', error);
    };
  };

  const storeEvents = (eventArray) => {
    if (eventArray.length > 0)
      sessionStorage.setItem('bbevents', JSON.stringify(eventArray));
  };

  const prettyTime = (ms) => {
    let mins = Math.floor(ms / 60000);
    if (mins === 0) { mins = mins + 1 };
    switch (mins < 60) {
      case true:
        if (mins === 1) {
          return mins + ' minute ago'
        } else {
          return mins + ' minutes ago'
        };
      break;
        
      case false:
      let hours = Math.floor(mins / 60);
      if (hours === 1) {
        return hours + ' hour ago'
      } else {
        return hours + ' hours ago'
      };
    };
  };

  const nextEvent = () => {
    let eventsArr = JSON.parse(sessionStorage.getItem('bbevents'));
    let nextEventData = eventsArr.shift();

    (eventsArr.length > 0) ?
      sessionStorage.setItem('bbevents', JSON.stringify(eventsArr)) :
      sessionStorage.removeItem('bbevents');
    return nextEventData;
  };

  const buildPopup = () => {
    let eventItem = nextEvent();
    let url = '/products/' + eventItem.handle;
    let img = eventItem.img;
    let title = eventItem.title;
    let city = eventItem.city;
    let timestamp = eventItem.timestamp;
    let timeDiff = Date.now() - timestamp;
    
    settings.prodImg.setAttribute('src', img);
    settings.prodImg.setAttribute('alt', title);
    settings.imgLink.href = url;
    settings.timeMsg.textContent = prettyTime(timeDiff);
    settings.description.innerHTML = `Someone in ${city} bought <a href="${url}" title="${title}">${title}</a>`;
  };

  // Controls popup slide up, pause, slide down animation
  const delayedClassToggle = (element, cssClass, duration) => {
    element.classList.add(cssClass);
    setTimeout(() => element.classList.remove(cssClass), duration);
  };
  
  const showPopup = () => {
    buildPopup();
    delayedClassToggle(settings.popup, 'bbpop-slide', 6500);
  };

  // Create random number for popup interval duration
  const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max + 1);
    return (Math.floor(Math.random() * (max - min)) + min);
  };

  // Fires popups after [firstInterval], then at random
  // intervals between [minInterval] and [maxInterval],
  // up to the maximum per page.
  const queuePops = () => {
    let firstInterval = settings.firstInterval;
    let minInterval = settings.minInterval;
    let maxInterval = settings.maxInterval;
    let popCount = settings.maxPops;

    const nextPop = () => {
      showPopup();
      popCount--;
    }

    setTimeout(() => {
      nextPop();
      const popTimer = () => {
        if (popCount > 0 && sessionStorage.getItem('bbevents')) {
          setTimeout(() => {
            if (hidePop === true) { return };
            nextPop();
            popTimer();
          }, getRandomInt(minInterval, maxInterval) * 1000);
        };
      };
      popTimer();
    }, firstInterval * 1000);
  };

  return {
    init: () => {
      if (hidePop === true) return;
      if (isPhone() === true) return;
      (async () => {
        try {
          if (sessionStorage.getItem('bbevents') === null) {
            let eventArray = await getEvents();
            await storeEvents(eventArray);
            queuePops();
          } else {
            queuePops();
          };
        }
        catch(error) { console.log(Error('Could not initialise bbpop', error))};
      })();
    },
    
    hide: (evt, closeBtn) => {
      if (evt.target === closeBtn) {
        let popup = settings.popup;
        popup.classList.remove('bbpop-slide');
        document.cookie = 'bbPopHide=true; path=/; max-age=86400';
        hidePop = true;
      };
    }
  };
})();

window.addEventListener('load', bbPop.init());

const closeBtn = document.querySelector('#bbpop-close-svg');
closeBtn.addEventListener('click', evt => bbPop.hide(evt, closeBtn));